import { put, take, takeLatest, call, select } from 'redux-saga/effects';

import contactService from 'services/contactService';

import { billingAddressDrawer, open, save, types } from './actions';
import { MODES } from './constants';
import { getAccountId, getBillingAddressId, getMode } from './reducer';

export default function* root() {
  yield takeLatest(types.OPEN_REQUEST, watchInitiateDrawer);
  yield takeLatest(types.SAVE_REQUEST, watchSaveBillingAddress);
}

function* watchInitiateDrawer(action) {
  try {
    const { callBack } = action.payload;
    const mode = yield select(getMode);
    if (mode === MODES.EDIT) {
      // fetch current billing address
      const billingAddressId = yield select(getBillingAddressId);
      const billingAddress = yield call(
        contactService.accounts.billingAddresses.get,
        billingAddressId,
      );

      yield put(billingAddressDrawer.setBillingAddress({ billingAddress }));
    }

    yield put(open.success());

    if (callBack) {
      const action = yield take(types.SAVE_SUCCESS);
      callBack({
        billingAddressId: action.payload.billingAddressId,
        billingAddress: action.payload.billingAddress,
      });
    }
  } catch (error) {
    yield put(open.error(error));
  }
}

function* watchSaveBillingAddress(action) {
  try {
    const { address1, address2, city, country, postalCode, state } =
      action.payload;

    const requestData = {
      address: {
        address1,
        address2,
        city,
        country,
        postalCode,
        state,
      },
    };

    const mode = yield select(getMode);
    let billingAddressId = yield select(getBillingAddressId);
    let billingAddress;
    if (mode == MODES.CREATE) {
      const accountId = yield select(getAccountId);
      const response = yield call(
        contactService.accounts.billingAddresses.create,
        accountId,
        requestData,
      );
      billingAddressId = response.id;
      billingAddress = response;
    } else {
      billingAddress = yield call(
        contactService.accounts.billingAddresses.update,
        billingAddressId,
        requestData,
      );
    }

    yield put(save.success({ billingAddressId, billingAddress }));
  } catch (error) {
    yield put(save.error(error));
  }
}
